__webpack_require__.p = "/mybets/assets/";